module.exports = __webpack_public_path__ + "static/media/rings-wedding.b7cebc90.svg";